let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jtHE4")).then(() => parcelRequire('g8de5'));